import { siteConfig } from "../config/site.js";
export function openUnarchivedRoute(path, replace = false) {
  const target = new URL(path, window.location.origin);
  if (
    !siteConfig.externalizeNavigation ||
    siteConfig.localRoutes.includes(target.pathname)
  )
    return false;
  const url = new URL(
    target.pathname + target.search + target.hash,
    siteConfig.originalOrigin,
  );
  if (replace) window.location.replace(url.href);
  else window.location.assign(url.href);
  return true;
}
